import { render, staticRenderFns } from "./tree-item.vue?vue&type=template&id=790a1e04"
import script from "./tree-item.vue?vue&type=script&lang=js"
export * from "./tree-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports